{
  "amount": "رقم",
  "available": "دستیاب",
  "bots": "بوٹس",
  "buyLong": "خریدیں / لانگ",
  "closePosition": "پوزیشن بند کریں",
  "cost": "لاگت",
  "cross": "کراس",
  "entryPrice": "انٹری قیمت",
  "funding": "فنڈنگ",
  "fundingRate": "فنڈنگ ریٹ",
  "futuresSettings": "فیوچرز سیٹنگز",
  "futuresSubtitle": "ریئل ٹائم فیوچرز ایکسچینج پینل",
  "futuresTitle": "ایگزالٹ فیوچرز ٹریڈنگ",
  "highVolatility": "زیادہ وولاٹیلٹی",
  "importantNotice": "اہم اطلاع: ایگزالٹ فیوچرز مارکیٹ لائیو ہے",
  "isolated": "آئسولیٹڈ",
  "leverage": "لیوریج",
  "limit": "لمٹ",
  "liquidation": "لیکویڈیشن",
  "liveFuturesMarket": "لائیو فیوچرز مارکیٹ",
  "loading": "لوڈ ہو رہا ہے...",
  "lowVolatility": "کم وولاٹیلٹی",
  "margin": "مارجن",
  "marginMode": "مارجن موڈ",
  "markPrice": "مارک قیمت",
  "market": "مارکیٹ",
  "mobileFuturesChart": "موبائل فیوچرز چارٹ",
  "noClosedPositions": "کوئی بند پوزیشن نہیں",
  "noOpenPositions": "کوئی اوپن پوزیشن نہیں",
  "normalCandles": "نارمل کینڈلز",
  "normalVolatility": "نارمل وولاٹیلٹی",
  "openLong": "لانگ کھولیں",
  "openOrders": "اوپن آرڈرز",
  "openPositions": "اوپن پوزیشنز",
  "openShort": "شارٹ کھولیں",
  "orderBook": "آرڈر بک",
  "orderType": "آرڈر ٹائپ",
  "perpetualFutures": "پرپیچوئل فیوچرز",
  "positionHistory": "پوزیشن ہسٹری",
  "positions": "پوزیشنز",
  "price": "قیمت",
  "priceMovementWarning": "ریگولر ٹریڈنگ اوقات کے باہر قیمت کی حرکت اور لیکویڈیٹی محدود ہو سکتی ہے۔",
  "processing": "پروسیسنگ ہو رہی ہے...",
  "quoteCurrency": "کوٹ کرنسی",
  "reduceOnly": "صرف کم کریں",
  "riskLevel": "رسک لیول",
  "searchMarket": "مارکیٹ تلاش کریں...",
  "searchPair": "پیئر تلاش کریں...",
  "sellShort": "بیچیں / شارٹ",
  "serverError": "سرور میں خرابی۔",
  "sessionExpired": "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "slPrice": "SL قیمت",
  "smoothCandles": "سموتھ کینڈلز",
  "stopLoss": "اسٹاپ لاس",
  "takeProfit": "ٹیک پرافٹ",
  "tpPrice": "TP قیمت",
  "tradingViewChart": "ٹریڈنگ ویو چارٹ",
  "volatileCandles": "وولاٹائل کینڈلز",
  "zoomLarge": "بڑا زوم",
  "zoomMedium": "درمیانہ زوم",
  "zoomSmall": "چھوٹا زوم"
}